export default __webpack_public_path__ + "static/media/2.18a17079.png";